(function () {
  'use strict';

  if (window.__customInstantVariantPillsBound) return;
  window.__customInstantVariantPillsBound = true;

  function refreshPillSelection(input) {
    if (!input || input.type !== 'radio' || !input.name) return;

    var picker = input.closest('variant-picker');
    if (!picker) return;

    var optionInputs = Array.prototype.filter.call(
      picker.querySelectorAll('input[type="radio"]'),
      function (radio) {
        return radio.name === input.name;
      }
    );

    var selectedId = '';
    var optionIds = optionInputs.map(function (radio) {
      if (radio.checked) selectedId = radio.id;
      return radio.id;
    });

    picker.querySelectorAll('.product-variant-picker__pill-list label[for]').forEach(function (label) {
      if (optionIds.indexOf(label.getAttribute('for')) === -1) return;

      var isSelected = label.getAttribute('for') === selectedId;
      label.classList.toggle('selected', isSelected);

      if (isSelected) {
        label.setAttribute('tabindex', '0');
      } else {
        label.removeAttribute('tabindex');
      }
    });

    var optionName = input.name.replace(/-\d+$/, '');
    var optionLabelContainer = Array.prototype.filter.call(
      picker.querySelectorAll('[data-variant-picker-option-labels]'),
      function (container) {
        return container.getAttribute('option-picker-name') === optionName;
      }
    )[0];
    var selectedValueLabel = optionLabelContainer
      ? optionLabelContainer.querySelector('[data-variant-picker-selected-value]')
      : null;

    if (selectedValueLabel) selectedValueLabel.textContent = input.value;
  }

  document.addEventListener(
    'change',
    function (event) {
      refreshPillSelection(event.target);
    },
    true
  );
})();
